/**
 * Products to pre-select in the auto-add "Products" box.
 *
 * The per-product checkbox columns only appear once a product is selected, so
 * an empty box leaves no way to pick cameras (a Genetec operator hit this on
 * 2026-10-05 and deployed an empty site). Never selects every product by
 * default — that would add detection the customer didn't choose.
 *
 * - The site's own onboarding products (ids), when any are on offer.
 * - Otherwise the only product, when the site offers exactly one.
 * - Otherwise nothing (the operator chooses).
 *
 * @param productPairs `[name, id]` pairs from `nvr_camera/product/`
 * @param siteProductIds the site's onboarding product ids
 *   (`customer/{id}/camera_onboarding_forms/` → `initial_data.products`)
 */
export const defaultAutoAddProducts = (
  productPairs: any,
  siteProductIds: any
): string[] => {
  if (!Array.isArray(productPairs) || productPairs.length === 0) return [];
  const pairs = productPairs.filter(
    (pair: any) => Array.isArray(pair) && pair.length >= 2
  );
  const ids = new Set(
    (Array.isArray(siteProductIds) ? siteProductIds : [])
      .map((id: any) => Number(id))
      .filter((id: number) => !Number.isNaN(id))
  );
  const siteProducts = pairs
    .filter((pair: any[]) => ids.has(Number(pair[1])))
    .map((pair: any[]) => String(pair[0]));
  if (siteProducts.length > 0) return siteProducts;
  if (pairs.length === 1) return [String(pairs[0][0])];
  return [];
};
